import { BaseService } from "services/_baseService";

class BranchesAdminService extends BaseService<any> {
  constructor() {
    super(`branches`);
  }
}

export default new BranchesAdminService();
